import { Component } from '@angular/core';
import { Platform,NavController , ToastController } from 'ionic-angular';

@Component({
  selector: 'page-info',
  templateUrl: 'info.html'
})
export class InfoPage {

  constructor(public toastCtrl: ToastController, public platform: Platform,public aboutusCtrl: NavController) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/info/info.ts